import * as React from 'react';

const SCROLL_SHADOW_THRESHOLD = 4;

export const useScrollShadows = (threshold = SCROLL_SHADOW_THRESHOLD) => {
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const [showTopShadow, setShowTopShadow] = React.useState(false);
  const [showBottomShadow, setShowBottomShadow] = React.useState(false);

  const onScroll = React.useCallback(() => {
    const el = scrollRef.current;

    if (!el) {
      return;
    }

    const { scrollTop, clientHeight, scrollHeight } = el;

    setShowTopShadow(scrollTop > threshold);
    setShowBottomShadow(scrollTop + clientHeight < scrollHeight - threshold);
  }, [threshold]);

  React.useEffect(() => {
    const el = scrollRef.current;

    if (!el) {
      return;
    }

    onScroll();
    const obs = new ResizeObserver(onScroll);

    obs.observe(el);

    return () => obs.disconnect();
  }, [onScroll]);

  return { scrollRef, showTopShadow, showBottomShadow, onScroll };
};
